export const INIT_section = () => {

    // Section: Collection / Reviews
    const sectionCR = [...document.querySelectorAll(".section--collections-reviews")];

    if (sectionCR) {
        sectionCR.forEach((section) => {
            setThemeRewards(section);

            window.addEventListener("click", (event) => {
                const trigger = event.target;

                if (trigger.hasAttribute("grit-theme-rewards")) {
                    setThemeRewards(section, trigger);
                }
            });
        });
    }

    function setThemeRewards(section, trigger = null) {
        let tabTrigger = section.querySelector(".g-tabs--nav--btn.is-active");
        const rewards = section.querySelector(".section--collections-reviews--rewards");
        const plus = section.querySelector(".section--collections-reviews--rewards--plus");
        const plusLogo = section.querySelector(".section--collections-reviews--rewards--plus--logo");
        const plusHeading = plus.querySelector("h2");
        const btnPrimary = section.querySelector(".section--collections-reviews--rewards--btn-primary");
        const btnSecondary = section.querySelector(".section--collections-reviews--rewards--btn-secondary");

        if (trigger) {
            tabTrigger = trigger;
        }

        resetThemeRewards(rewards);
        resetThemeRewards(plus);
        resetThemeRewards(plusLogo);
        resetThemeRewards(plusHeading);
        resetThemeRewards(btnPrimary);
        resetThemeRewards(btnSecondary);

        rewards.classList.add(tabTrigger.dataset.rewards);
        plus.classList.add(tabTrigger.dataset.rewardsPlus);
        plusLogo.classList.add(tabTrigger.dataset.rewardsPlusLogo);
        plusHeading.classList.add(tabTrigger.dataset.rewardsPlusHeading);
        btnPrimary.classList.add(tabTrigger.dataset.rewardsBtnPrimary);
        btnSecondary.classList.add(tabTrigger.dataset.rewardsBtnSecondary);
    }

    function resetThemeRewards(elem) {
        [...elem.classList].forEach((className) => {
            if (
                className.includes("bg-") ||
                className.includes("color-") ||
                className.includes("fill-")
            ) {
                elem.classList.remove(className);
            }
        });
    }
};
